import React from 'react'
import { reduxForm } from 'redux-form'
import MoneyInput from 'components/money-input'
import { required } from '@cred/shared/validations'
import PropTypes from 'prop-types'
import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'
import Font from '@cred/react-font'
import { minMaxBalanceAmount } from '../validations'
import styles from './styles.scss'

/* eslint-disable indent */
const FilterForm = ({ closeModal, update, reset, invalid, withFooter, onAmountChange }) => {
  const cancel = () => {
    closeModal()
    // Setting timeout so the form doesn't reset as the modal is disappearing
    setTimeout(reset, 500)
  }

  return (
    <>
      <form className={`${styles.filters} pure-g`} method="POST" onSubmit={e => { e.preventDefault() }}>
        <div className="pure-u-1 pure-u-md-1-2 pure-u-sm-11-24">
          <div className="mr-md-8 mb-16 mb-sm-8 mb-md-0">
            <Font className={styles.title} type="bodySmall" weight="semiBold">Enter your balance amount:</Font>
            <MoneyInput
              name="balanceAmount"
              label="Balance amount"
              onChange={onAmountChange}
              exposeValue
              placeholder="Balance amount"
              validate={[required, minMaxBalanceAmount]}
              icon={false}
            />
          </div>
        </div>
      </form>
      {withFooter && <Footer cancel={cancel} invalid={invalid} update={update} />}
    </>
  )
},

noop = () => { }

FilterForm.propTypes = {
  closeModal: PropTypes.func,
  update: PropTypes.func,
  reset: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
  onAmountChange: PropTypes.func,
}

FilterForm.defaultProps = {
  closeModal: noop,
  update: noop,
  reset: noop,
  onAmountChange: noop,
  withFooter: false,
}

export { FilterForm as FilterFormNoHoc }

export default reduxForm({
  keepDirtyOnReinitialize: false,
  enableReinitialize: true,
})(FilterForm)
